// extracted by mini-css-extract-plugin
export default {"button":"VolumeButton_button__MTTJ0","container":"VolumeButton_container__gT4cJ","wrapper":"VolumeButton_wrapper__8C5HZ","rangeInput":"VolumeButton_rangeInput__tJ-NN"};